import { FC } from "react";
import {
  FormControl,
  FormErrorMessage,
  Flex,
  NumberDecrementStepper,
  NumberIncrementStepper,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  SystemStyleObject,
  Text,
} from "@chakra-ui/react";
import LabelComponent from "../../atom/Label/LabelComponent";
import { Control, useController } from "react-hook-form";

interface NumberInputFieldComponentProps {
  label?: string;
  name: string;
  onChange?: (inputValue: number | string | null) => void;
  errors?: any;
  isRequired?: boolean;
  isDisabled?: boolean;
  additionalStyle?: SystemStyleObject;
  control: Control<any>;
  extraText?: string;
}

const NumberInputFieldComponent: FC<NumberInputFieldComponentProps> = ({
  label,
  name,
  onChange,
  errors,
  isRequired = false,
  isDisabled = false,
  additionalStyle,
  control,
  extraText,
}) => {
  const {
    field: { onChange: onChangeField, onBlur, value },
  } = useController({
    name,
    control,
  });

  const handleValueChange = (inputValue: string) => {
    if (inputValue === "") {
      onChangeField(null);
      onChange && onChange(null);
    } else {
      const numericValue = Number(inputValue);
      onChangeField(numericValue);
      onChange && onChange(numericValue);
    }
  };

  return (
    <FormControl isInvalid={errors && !!errors[name]}>
      {label && (
        <LabelComponent
          title={label}
          fontWeight="500"
          fontSize="md"
          {...(isRequired && { isRequired })}
        />
      )}
      <Flex gap={2.5} alignItems="flex-end">
        <NumberInput
          value={value === null || value === undefined ? "" : value}
          onChange={handleValueChange}
          isDisabled={isDisabled}
        >
          <NumberInputField sx={additionalStyle} onBlur={onBlur} />
          <NumberInputStepper>
            <NumberIncrementStepper />
            <NumberDecrementStepper />
          </NumberInputStepper>
        </NumberInput>
        {extraText && (
          <Text whiteSpace="nowrap" pb="2">
            {extraText}
          </Text>
        )}
      </Flex>
      <FormErrorMessage>
        {errors && errors[name] && errors[name].message}
      </FormErrorMessage>
    </FormControl>
  );
};

export default NumberInputFieldComponent;
